import { PartnerManager } from 'types/partnerManager';

export const createPartnerManager = (): PartnerManager => ({
  partnerId: null,
  screen: { name: 'SUMMARY' },
  data: null,
  dataInvalidated: false,
});
